import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

@Component({
    selector: 'lui-context-menu-container',
    template: `
    <ng-content select="lui-context-menu" *ngIf="_opened"></ng-content>
    <ng-content select="[luiContextMenuButtonFor]"></ng-content>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ContextMenuContainerComponent {
  @HostBinding('class') className = 'lui-context-menu-container';

  @Input() get opened() {
    return this._opened;
  }
  set opened(value: BooleanInput) {
    this._opened = coerceBooleanProperty(value);
  }

  _opened = false;

  constructor(private _cd: ChangeDetectorRef) {}

  open() {
    this._opened = true;
    this._cd.markForCheck();
  }

  close() {
    this._opened = false;
    this._cd.markForCheck();
  }

  toggle(opened: boolean = !this._opened) {
    if (opened) {
      this.open();
    } else {
      this.close();
    }
  }
}
